var map = {
	"./1.png": 113,
	"./2.png": 4903,
	"./3.png": 7548,
	"./4.png": 8127,
	"./5.png": 8338,
	"./6.png": 7102,
	"./facebook.png": 8391,
	"./instagram (1).png": 8453,
	"./twitter.png": 1342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8772;